import Loadable from "react-loadable";
import { EmptyComponent } from "../common/EmptyComponent.js";

export const SettingsMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "settings/mobile/settings" */
      "./Settings.mobile.MenuItem.js"
    ),
  loading: EmptyComponent
});

export const SettingsPC = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "settings/pc/settings.header" */
      "./Settings.pc.HeaderItem.js"
    ),
  loading: EmptyComponent
});
